export const CategoryDefaultValue: ICategory["get"] = {
    id: 0,
    faName: "",
    enName: "",
    url: "",
    image: "",
    parent: null,
    description: "",
    seoDescription: "",
    seoKeywords: "",
    updateDateTime: "",
    createDateTime: "",
};
